/** Plain-language reason an alert was resolved (#85). Unknown codes fall back to the code itself. */
const LABELS: Record<string, string> = {
  cleared: 'condition cleared',
  manual: 'resolved by a person',
  no_data_recovered: 'data came back',
  sdt_expired_clear: 'maintenance window ended and the condition had cleared',
  external_sync: 'resolved in a connected system',
  resource_deleted: 'the resource was deleted',
  assignment_removed: 'the sensor no longer applies to this resource',
  monitoring_disabled: 'monitoring was turned off for the resource',
};

export function resolveReasonLabel(reason: string | null | undefined): string {
  if (!reason) return '';
  return LABELS[reason] ?? reason;
}
